module.exports = __webpack_public_path__ + "/bundle/asset/faq-1-4-409cbe484b53c41ea687e7b2426f7130.png";